import React from "react";
import { clsx } from "clsx";

export type TextElements = Extract<
  keyof JSX.IntrinsicElements,
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "a"
  | "strong"
  | "b"
  | "sup"
  | "button"
>;

type Elements = keyof JSX.IntrinsicElements | React.ElementType;

export type LayoutElements = Extract<
  keyof JSX.IntrinsicElements,
  | "article"
  | "section"
  | "header"
  | "footer"
  | "aside"
  | "div"
  | "ul"
  | "ol"
  | "li"
>;

export type NavigationalElements = Extract<
  keyof JSX.IntrinsicElements,
  "a" | "button" | "span"
>;

export type BoxProps<As extends Elements = "div"> = {
  as?: As;
  children?: React.ReactNode;
  className?: string | string[];
  style?: React.CSSProperties;
} & React.ComponentPropsWithoutRef<As>;

export const Box = React.forwardRef(
  <As extends Elements = "div">(
    {
      as: Component = "div" as As,
      children,
      className = "",
      style,
      ...rest
    }: BoxProps<As>,
    ref: React.ForwardedRef<HTMLElement>
  ): JSX.Element => {
    const compoundClassName = clsx(className);
    const elementProps = { ...rest, className: compoundClassName, style };

    return React.createElement(Component, { ...elementProps, ref }, children);
  }
);
